// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValueList__values__TUyhv{display:flex;align-self:flex-end}
`, "",{"version":3,"sources":["webpack://./src/js/apps/binder/components/BinderSetup/ValueSets/ValueList/ValueList.scss"],"names":[],"mappings":"AAAA,0BACI,YAAa,CACb,mBAAoB","sourcesContent":[".values {\n    display: flex;\n    align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"values": `ValueList__values__TUyhv`
};
export default ___CSS_LOADER_EXPORT___;
